import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/app/(main)/money2020/pageBody.tsx");
